import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faRocket, faTimes, faCheck, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { DeploymentsService, DeployModelRequest } from '../../services/deployments.service';
import { ConfigurationsService, Configuration } from '../../services/configurations.service';
import { Model } from '../../services/models.service';
import { AlertService } from '../alert-service/alert-service';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-modal-deploy-model',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule, TranslateModule, NgSelectModule, ButtonComponent],
  templateUrl: './modal-deploy-model.component.html',
  styleUrls: ['./modal-deploy-model.component.scss']
})
export class ModalDeployModelComponent implements OnInit {
  @Input() show = false;
  @Input() model: Model | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() deployed = new EventEmitter<void>();

  faRocket = faRocket;
  faTimes = faTimes;
  faCheck = faCheck;
  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;

  loading = false;

  llmModelOptions: Configuration[] = [];

  defaultValueMode: 'default' | 'empty' | 'custom' = 'default';

  deployRequest: DeployModelRequest = {
    llmModel: 'M1.1',
    language: 'pt',
    extractionDefaultValue: null,
    extractionDefaultProbability: 0.0,
    ocrType: 'azure4',
    textType: 'mix',
    ocrCrop: false,
    ocrSort: false,
    autoCut: false,
    enhanceDocument: false,
    splitPdf: false,
    layoutAnalysis: '',
    adjustRotation: ''
  };

  constructor(
    private deploymentsService: DeploymentsService,
    private configurationsService: ConfigurationsService,
    private alert: AlertService
  ) {}

  ngOnInit(): void {
    this.loadLlmModelOptions();
  }

  private loadLlmModelOptions(): void {
    this.configurationsService.listAllowedForMe().subscribe({
      next: res => {
        this.llmModelOptions = (res.configurations || []).filter(c => c.type === 'delfos_llm');
      },
      error: () => {
        this.llmModelOptions = [];
      }
    });
  }

  onDefaultValueModeChange(): void {
    if (this.defaultValueMode === 'default') {
      this.deployRequest.extractionDefaultValue = null;
    } else if (this.defaultValueMode === 'empty') {
      this.deployRequest.extractionDefaultValue = '';
    } else {
      this.deployRequest.extractionDefaultValue = '';
    }
  }

  onClose() {
    this.close.emit();
    this.loading = false;
  }

  onDeploy() {
    if (!this.model?.id) return;
    
    this.loading = true;
    this.deploymentsService.deploy(String(this.model.id), this.deployRequest).subscribe({
      next: () => {
        this.alert.showSuccess('MODELS.DEPLOY.SUCCESS');
        this.deployed.emit();
        this.onClose();
      },
      error: (err) => {
        this.alert.showError(err);
        this.loading = false;
      }
    });
  }
}
